import { render, staticRenderFns } from "./ColdStats2_test.vue?vue&type=template&id=5dc22488&"
import script from "./ColdStats2_test.vue?vue&type=script&lang=js&"
export * from "./ColdStats2_test.vue?vue&type=script&lang=js&"
import style0 from "./ColdStats2_test.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports